import { useEffect, useState } from 'react'
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import resolveRefund from './api'
import { RESOLVE_NOTE, resolveOutcome } from './utils'

const MUTED = 'text-gray-500 dark:text-gray-400'

export default function ResolveRefundDialog({ open, transactionId, details = [], onClose, onResolved }) {
  const [sending, setSending] = useState(false)
  const [outcome, setOutcome] = useState(null)

  useEffect(() => {
    if (open) setOutcome(null)
  }, [open])

  const close = () => {
    if (!sending) onClose()
  }

  const submit = async () => {
    setSending(true)
    setOutcome(null)
    const next = resolveOutcome(await resolveRefund(transactionId))
    setSending(false)
    setOutcome(next)
    if (next.done) onResolved(next.update)
  }

  const finished = Boolean(outcome?.done)

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth='sm'>
      <DialogTitle>Resolver reembolso manual</DialogTitle>
      <DialogContent>
        <div className='flex flex-col gap-4 pt-1'>
          <dl className='grid grid-cols-[auto,1fr] gap-x-4 gap-y-1 text-sm'>
            <dt className={MUTED}>ID</dt>
            <dd className='font-mono break-all'>{transactionId}</dd>
            {details.map(([label, value]) => (
              <div key={label} className='contents'>
                <dt className={MUTED}>{label}</dt>
                <dd className='break-words'>{value || '-'}</dd>
              </div>
            ))}
          </dl>

          {!finished && <p className={`text-sm ${MUTED}`}>{RESOLVE_NOTE}</p>}

          {outcome && <Alert severity={outcome.severity}>{outcome.message}</Alert>}
        </div>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {finished ? (
          <button
            className='px-3 py-2 rounded-lg text-sm font-semibold bg-primary text-white hover:opacity-90 transition-opacity'
            onClick={close}
          >
            Listo
          </button>
        ) : (
          <>
            <button
              className='px-3 py-2 rounded-lg text-sm hover:bg-gray-100 dark:hover:bg-dk-hover disabled:opacity-50'
              onClick={close}
              disabled={sending}
            >
              Cancelar
            </button>
            <button
              className='px-3 py-2 rounded-lg text-sm font-semibold bg-primary text-white hover:opacity-90 transition-opacity disabled:opacity-50'
              onClick={submit}
              disabled={sending || !transactionId}
            >
              {sending ? 'Resolviendo…' : 'Resolver'}
            </button>
          </>
        )}
      </DialogActions>
    </Dialog>
  )
}
